import { render, staticRenderFns } from "./report_device_page.vue?vue&type=template&id=56da72e4"
import script from "./report_device_page.vue?vue&type=script&lang=js"
export * from "./report_device_page.vue?vue&type=script&lang=js"
import style0 from "./report_device_page.vue?vue&type=style&index=0&id=56da72e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports